var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { staticClass: "flex flex-center" }, [
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submitLogin.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "q-card",
          {
            staticClass: "md-card q-mt-lg relative-position",
            attrs: { color: "grey-1" }
          },
          [
            _c("q-card-title", { staticClass: "bg-secondary text-white" }, [
              _vm._v("Forgot Password")
            ]),
            _c("q-card-separator"),
            _c(
              "q-card-main",
              [
                _c(
                  "q-field",
                  {
                    staticClass: "q-mt-lg q-mb-lg text-black",
                    attrs: {
                      label: "Email Address",
                      orientation: "vertical",
                      icon: "email",
                      helper:
                        "please type in your email address to reset your password"
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: { autofocus: "", type: "email" },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                ),
                _vm.error
                  ? _c(
                      "div",
                      [
                        _c(
                          "q-alert",
                          {
                            attrs: {
                              color: "negative",
                              icon: "error",
                              enter: "fadeIn",
                              leave: "fadeOut",
                              appear: "",
                              dismissible: ""
                            }
                          },
                          [
                            _c("b", [
                              _vm._v("Issue requesting password reset:")
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.error) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.message
                  ? _c(
                      "div",
                      { staticClass: "q-ma-lg" },
                      [
                        _c(
                          "q-alert",
                          {
                            attrs: {
                              color: "blue-4",
                              icon: "info",
                              enter: "fadeIn",
                              leave: "fadeOut",
                              appear: "",
                              dismissible: ""
                            }
                          },
                          [_vm._v(_vm._s(_vm.message))]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            !_vm.requiresEmail
              ? _c(
                  "q-card-actions",
                  [
                    _c(
                      "q-btn",
                      {
                        staticClass: "full-width no-shadow",
                        attrs: {
                          loader: "",
                          large: "",
                          color: "primary",
                          type: "submit",
                          disabled: _vm.loading,
                          label: "Send Email"
                        },
                        model: {
                          value: _vm.loading,
                          callback: function($$v) {
                            _vm.loading = $$v
                          },
                          expression: "loading"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "loading" }, slot: "loading" },
                          [
                            _c("q-spinner", { staticClass: "on-left" }),
                            _vm._v("Requesting Password Email ...\n          ")
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c("q-inner-loading", { attrs: { visible: _vm.loading } })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }